import { centerable as l } from "../decorators/centerable.js";
import { uploadable as i } from "../decorators/uploadable.js";
import { BLOCK_CLASSES as o } from "../../constants.js";
import "../../bundled_deps/.pnpm/tinycolor2@1.6.0/bundled_deps/tinycolor2/esm/tinycolor.js";
const p = l(
  i({
    inline: !1,
    draggable: !0,
    attrs: {
      type: { default: "videoFile" },
      duration: { default: 0 },
      url: { default: "" },
      thumbnailUrl: { default: "" },
      captions: { default: "" }
    },
    group: "block",
    parseDOM: [
      {
        tag: ".intercom-interblocks-video-file",
        getAttrs(t) {
          let e = t.querySelector("a"), r = t.querySelector("img");
          return {
            thumbnailUrl: r.getAttribute("src"),
            url: e.getAttribute("href"),
            captions: r.getAttribute("alt") || ""
          };
        }
      },
      {
        tag: ".embercom-prosemirror-composer-block-container.embercom-prosemirror-composer-video video",
        getAttrs(t) {
          let e = t.querySelector("source");
          return {
            thumbnailUrl: t.getAttribute("poster"),
            url: e.getAttribute("src"),
            captions: e.getAttribute("alt") || ""
          };
        }
      }
    ],
    toDOM(t) {
      return [
        "div",
        {
          class: `${o.blockContainer} ${o.video}`
        },
        [
          "video",
          {
            class: "block-video-file-player",
            controls: "pause play mute",
            poster: t.attrs.thumbnailUrl,
            style: "display: block; width: 100%; height: 100%;"
          },
          [
            "source",
            {
              src: t.attrs.url,
              alt: t.attrs.captions
            }
          ]
        ]
      ];
    }
  })
);
export {
  p as videoFileSpec
};
